module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-04.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-04.png
// module id = 1379
// module chunks = 0